import { useMemo } from "react";
import { useInfiniteQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "../constants";
import {
  handleGetAllGames,
  GetAllGamesParams,
} from "../../api-clients/gamesClient";
import { extractInfoFromInfiniteData, extractListRecords } from "../utils";

interface UseInfiniteGamesQueryParams extends GetAllGamesParams {
  enabled?: boolean;
  maxPages?: number;
}

function useInfiniteGamesQuery(params: UseInfiniteGamesQueryParams = {}) {
  const {
    enabled,
    page,
    limit,
    provider,
    sort,
    status,
    category,
    gameType,
    platform,
    maxPages,
  } = params;

  const query = useInfiniteQuery({
    queryKey: [QUERY_KEYS.GAME.ALL_GAMES, category, page, gameType],
    queryFn: ({ pageParam }) =>
      handleGetAllGames({
        platform,
        page: pageParam,
        limit,
        provider,
        sort,
        status,
        category,
        gameType,
      }),
    initialPageParam: page || 1,
    maxPages,
    getNextPageParam: (lastPage) => lastPage.nextPage,
    getPreviousPageParam: (lastPage) => lastPage.previousPage,
    enabled,
  });

  const allGamesList = useMemo(
    () => extractInfoFromInfiniteData(query.data),
    [query.data]
  );

  const allGames = useMemo(
    () => extractListRecords(allGamesList),
    [allGamesList]
  );

  return { query, allGames };
}

export default useInfiniteGamesQuery;
